import React from 'react';
import capitalize from 'capitalize';

export default class GameOptionButton extends React.Component {

  constructor(props, context) {
    super(props, context);
  }

  classSelected() {
    const font = this.props.button == this.props.current ? 'fa-check-circle-o' : '';
    return `hidden-picture__options-square fa ${font}`;
  }

  render() {
    const label = this.props.label || capitalize(this.props.button);
    return(
      <div className="hidden-picture__options-button"
        onClick={this.props.action.bind(this, this.props.button)}>
        <span className={this.classSelected()}></span>
        <span className="hidden-picture__options-label">{label}</span>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/hidden-picture/game-option-button.js
 **/